import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { InfoModalEvent, RadioGroupItemProps } from '@nx-ng/types';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'nx-ng-radio-group-item',
  templateUrl: './radio-group-item.component.html',
  styleUrls: ['./radio-group-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioGroupItemComponent<T> {
  @Input()
  groupName?: string;

  @Input()
  item?: RadioGroupItemProps<T>;

  @Input()
  selected?: T;

  @Input()
  radiogGroupInvalid = false;

  @Input()
  showMoreInfoText = true;

  @Output()
  selection: EventEmitter<T> = new EventEmitter<T>();

  @Output()
  blur: EventEmitter<T> = new EventEmitter<T>();

  @Output()
  action: EventEmitter<InfoModalEvent> = new EventEmitter<InfoModalEvent>();

  public actionId = `${this.groupName}-${uuidv4()}`;

  public isInfo(i: RadioGroupItemProps<T>) {
    return i.action?.actionStyle === 'info';
  }

  public isParentheses(i: RadioGroupItemProps<T>) {
    return i.action?.actionStyle === 'parentheses';
  }

  public isChecked(value: T): boolean {
    return value === this.selected;
  }

  public makeId(i: RadioGroupItemProps<T>) {
    return this.groupName + '-' + i.titleKey;
  }

  handleActionClick(): void {
    const payload = {
      category: this.item?.action?.modalType,
      domain: this.groupName,
      subdomain: this.item?.titleKey,
    } as InfoModalEvent;
    this.action.emit(payload);
  }

  handleChange(): void {
    this.selection.emit(this.item?.value);
  }

  handleBlur(): void {
    setTimeout(() => {
      const element = document?.activeElement as HTMLInputElement;
      if (this.groupName && !element?.id.startsWith(this.groupName)) {
        this.blur.emit();
      }
    });
  }
}
